<div>
  <div class="breadcrumbs">
    <button class="back-button" (click)="navigateToDashboard()">
        <mat-icon>arrow_back_ios</mat-icon>
        <span class="breadcrumb-text">{{ breadcrumbTextHome }}</span>
    </button>
    <span class="breadcrumb-text">{{ breadcrumbTextUserSettings }}</span>
  </div>
<content-panel class="container">
  <panel-header
    [heading]="
      'CQMS Users' +
      (plantName
        ? ' — ' + plantName + ' (' + plantNumber + ')'
        : plantNumber
          ? ' — ' + plantNumber
          : '')
    "
  ></panel-header>
  <panel-body>
    <section>
      <table mat-table [dataSource]="tableData" class="users-table">
        <ng-container matColumnDef="userId">
          <th mat-header-cell *matHeaderCellDef><b>User ID</b></th>
          <td mat-cell *matCellDef="let row">{{ row.id }}</td>
        </ng-container>

        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef><b>First Name</b></th>
          <td mat-cell *matCellDef="let row">{{ row.firstName }}</td>
        </ng-container>

        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef><b>Last Name</b></th>
          <td mat-cell *matCellDef="let row">{{ row.lastName }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef><b>Email</b></th>
          <td mat-cell *matCellDef="let row">{{ row.email }}</td>
        </ng-container>

        <ng-container matColumnDef="zones">
          <th mat-header-cell *matHeaderCellDef><b>Zone Assignments</b></th>
          <td mat-cell *matCellDef="let row">
            <div class="zone-pills">
              @if (!row.empty) {
                @for (zone of visibleZones(row); track zone.zoneId) {
                  <span class="zone-pill">{{ zone.zoneName }}</span>
                }

                @if ((row.zoneAssignments?.length ?? 0) === 0) {
                  <span class="no-zones">No Zone Assignments</span>
                } @else if (!isExpanded(row.id) && overflowCount(row) > 0) {
                  <span
                    class="zone-pill zone-pill-more"
                    (click)="toggleZoneExpand(row.id, $event)"
                    title="Show all zones"
                  >
                    +{{ overflowCount(row) }} more
                  </span>
                } @else if (
                  isExpanded(row.id) &&
                  (row.zoneAssignments?.length ?? 0) > ZONE_PILL_LIMIT
                ) {
                  <span
                    class="zone-pill zone-pill-collapse"
                    (click)="toggleZoneExpand(row.id, $event)"
                    title="Show fewer zones"
                  >
                    <mat-icon inline>expand_less</mat-icon> less
                  </span>
                }
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" class="actions-cell">
            @if (!row.empty) {
              <button
                mat-icon-button
                color="primary"
                (click)="editUser(row)"
                title="Edit user"
              >
                <mat-icon>edit</mat-icon>
              </button>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="empty-row">
          <td
            *matCellDef="let row"
            [attr.colspan]="displayedColumns.length"
            class="empty-cell"
          >
            No users found.
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="
            let row;
            columns: users.length ? displayedColumns : ['empty-row']
          "
        ></tr>
      </table>
    </section>
  </panel-body>
</content-panel>
</div>
